const initPromotionalTabs = (scope = document) => {
  scope.querySelectorAll("[data-promotional-tabs]").forEach((section) => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = "true";
    section.querySelectorAll("[data-promo-tab]").forEach((button) => {
      button.addEventListener("click", () => {
        section
          .querySelectorAll("[data-promo-tab]")
          .forEach((tab) =>
            tab.setAttribute("aria-selected", String(tab === button)),
          );
        section.querySelectorAll("[data-promo-panel]").forEach((panel) => {
          panel.hidden = panel.dataset.promoPanel !== button.dataset.promoTab;
        });
        if (window.matchMedia("(max-width: 989px)").matches) {
          button.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        }
      });
    });
  });
};

const initProductDescriptionLinks = () => {
  if (document.documentElement.dataset.productDescriptionLinksInitialized)
    return;
  document.documentElement.dataset.productDescriptionLinksInitialized = "true";

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-view-product-description]");
    if (!link) return;

    const tabs = document.querySelector("[data-promotional-tabs]");
    if (!tabs) return;
    event.preventDefault();

    const descriptionTab = tabs.querySelector("[data-promo-tab]");
    if (!descriptionTab) return;
    descriptionTab.click();
    requestAnimationFrame(() =>
      tabs.scrollIntoView({ behavior: "smooth", block: "start" }),
    );
  });
};

const initPriceBreakupLinks = () => {
  if (document.documentElement.dataset.priceBreakupLinksInitialized) return;
  document.documentElement.dataset.priceBreakupLinksInitialized = "true";

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-view-price-breakup]");
    if (!button) return;

    const product = document.querySelector("[data-promotional-product]");
    const pricingToggle = product?.querySelector("[data-bulk-pricing-toggle]");
    const pricing = product?.querySelector("[data-bulk-pricing]");
    if (!product || !pricingToggle || !pricing) return;

    const brandedOption = product.querySelector('[data-order-type="2"]');
    if (brandedOption && !brandedOption.checked) {
      brandedOption.checked = true;
      brandedOption.dispatchEvent(new Event("change", { bubbles: true }));
    }
    if (pricingToggle.getAttribute("aria-expanded") !== "true") {
      pricingToggle.click();
    }
    requestAnimationFrame(() =>
      pricing.scrollIntoView({ behavior: "smooth", block: "start" }),
    );
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initPromotionalTabs();
  initProductDescriptionLinks();
  initPriceBreakupLinks();
});
document.addEventListener("shopify:section:load", (event) => {
  initPromotionalTabs(event.target);
  initProductDescriptionLinks();
  initPriceBreakupLinks();
});
